import { AxiosError } from 'axios';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { requisitesApi } from 'api';
import {
  CloseDialogHandler,
  CloseFormikDialogResult,
  Dialog,
} from 'components';
import { useMutation, useQueryFilters } from 'hooks';
import { TranslationNamespace } from 'i18n';
import { QueryParams, Requisites, RequisitesFilters } from 'types';

type Values = {
  blockedMessage: string;
};

type Props = {
  open: boolean;
  count?: number;
  onClose: CloseDialogHandler;
};

export const BatchUnblockRequisitesDialog: React.FC<Props> = ({
  open,
  count,
  onClose,
}) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.requisites.requisites_list.batch_unblock_dialog',
  });
  const { filtersQuery } = useQueryFilters<RequisitesFilters>();

  const mutation = useMutation<Requisites, AxiosError, Partial<QueryParams>>(
    requisitesApi.batchUnblock,
    {
      onSuccess: () => onClose({ ok: true }),
      notifierType: 'execute',
      notifierMessages: {
        success: (data) => t('result', { affected: data?.affected }),
      },
    },
  );

  const handleClose = useCallback(
    (result: CloseFormikDialogResult<Values>) => {
      if (result.ok) {
        mutation.mutate({ filters: filtersQuery });
      } else {
        mutation.reset();
        onClose({ ok: false });
      }
    },
    [mutation, filtersQuery, onClose],
  );

  return (
    <Dialog
      open={open}
      mutation={mutation}
      title={t('title')}
      onClose={handleClose}
    >
      <div>{`${t('selected_requisites_count')}: ${count}`}</div>
    </Dialog>
  );
};
